import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import {
  ADVERT_LIST_BY_DATE_INIT_URL,
  ADVERT_LIST_BY_DATE_LOAD_MORE_URL,
  API_ADVERT_LIST_BY_DATE_NAME,
} from '#advertList/constants';
import { InitResponseType, LoadMoreResponseType, LoadMorePayloadType } from '#advertList/api/by-date/types';
import { InitPayloadType } from '#advertList/api/types';

const getApiAdvertListByDate = (diContainer: Container) => {
  const apiAdvertListByDate = createApi({
    reducerPath: API_ADVERT_LIST_BY_DATE_NAME,
    baseQuery: getBaseQuery(diContainer),
    endpoints: (builder) => ({
      init: builder.query<InitResponseType, InitPayloadType>({
        query: (
          {
            categoryId,
            nationalityId,
            cityId,
            areaId,
          },
        ) => ({
          url: ADVERT_LIST_BY_DATE_INIT_URL,
          params: {
            categoryId,
            nationalityId,
            cityId,
            areaId,
          },
        }),
      }),
      loadMore: builder.query<LoadMoreResponseType, LoadMorePayloadType>({
        query: ({
          categoryId,
          nationalityId,
          cityId,
          areaId,
          page,
        }) => ({
          url: ADVERT_LIST_BY_DATE_LOAD_MORE_URL,
          params: {
            categoryId,
            nationalityId,
            cityId,
            areaId,
            page,
          },
        }),
        async onQueryStarted(
          {
            categoryId,
            nationalityId,
            cityId,
            areaId,
          },
          { dispatch, queryFulfilled },
        ) {
          const { data } = await queryFulfilled;
          dispatch(
            apiAdvertListByDate.util.updateQueryData(
              'init',
              {
                categoryId,
                nationalityId,
                cityId,
                areaId,
              },
              (draft) => {
                draft.advertDataList.pagination = data.advertDataList.pagination;
                draft.advertDataList.chunkDataList.push(...data.advertDataList.chunkDataList);
              },
            ),
          );
        },
      }),
    }),
  });
  return apiAdvertListByDate;
};

export { getApiAdvertListByDate };
